import type { MapperOptions } from '#layers/core/types'

/**
 * Page policies and disclaimer detail mapper
 * normalizes data to be used in pages
 *
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }
  return {
    contentLocale: data.locale || '',
    introText: data.introText || null,
    highlightText: data.highlightText || null,
    chapters: data.chaptersCollection?.items || [],
    navigationItems:
      data?.parent?.itemsCollection?.items.filter(Boolean).map((item: any) => ({
        title: item.navigationTitle,
        url: options.getInternalUrl(item.sys.id)
      })) || []
  }
}
